import axiosInstance from '../utils/axios';

class FilterService {
    constructor() {
      this.baseUrl = '/filters';
      this.axios = axiosInstance; // Use the imported axiosInstance directly
    }

    // Create a filter condition
    async createFilterCondition(filter) {
        try {
            if (filter && filter.id && filter.id !== '') {
                const response = await this.axios.put(`${this.baseUrl}/${encodeURIComponent(String(filter.id))}`, filter);
                return response.data;
            } else {
                const response = await this.axios.post(`${this.baseUrl}`, filter);
                return response.data;
            }
        } catch (error) {
            return error?.response?.data
        }
    }

    // Handle API errors
    handleError(error) {
        if (error.response) {
            return {
                message: error.response.data.message || 'An error occurred',
                errors: error.response.data.errors || {},
                status: error.response.status
            };
        } else if (error.request) {
            return {
                message: 'No response from server',
                status: 0
            };
        } else {
            return {
                message: error.message,
                status: 0
            };
        }
    }
}

export default new FilterService(); 